export const Images = {
  ArtefactBot: require('../../assets/img/boticons/ArtefactBot.png'),
  KazantzakisBot: require('../../assets/img/boticons/KazantzakisBot.png'),
  MuseumBot: require('../../assets/img/boticons/MuseumBot.png'),
  ServiceBot: require('../../assets/img/boticons/ServiceBot.png'),
};

